import { render, staticRenderFns } from "./NewsPreviousForecastRenderer.vue?vue&type=template&id=96b2f04c&"
import script from "./NewsPreviousForecastRenderer.vue?vue&type=script&lang=js&"
export * from "./NewsPreviousForecastRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports